module.exports = __webpack_public_path__ + "img/venuetwo-insuretitle.dc33c7ad.png";